import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import bannerImg from "../../../assets/banner.jpg";
import "./style.css";

const Leadership = ({ data }) => {
	const [isBeginning, setIsBeginning] = useState(true);
	const [isEnd, setIsEnd] = useState(false);
	const lang = useSelector((state) => state?.lang?.lang);
	const { t } = useTranslation();
	const prevRef = useRef(null);
	const nextRef = useRef(null);

	return (
		<div className="leadership" id="leadership">
			<div className="container">
				<p className="title">{t("work team")}</p>
				<div className="position-relative">
					<button className="button-prev" ref={prevRef}>
						<svg
							width="54"
							height="54"
							viewBox="0 0 54 54"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M27.0002 0.333496C12.3068 0.333496 0.333496 12.3068 0.333496 27.0002C0.333496 41.6935 12.3068 53.6668 27.0002 53.6668C41.6935 53.6668 53.6668 41.6935 53.6668 27.0002C53.6668 12.3068 41.6935 0.333496 27.0002 0.333496ZM31.7735 35.0002C32.5468 35.7735 32.5468 37.0535 31.7735 37.8268C31.3735 38.2268 30.8668 38.4135 30.3602 38.4135C29.8535 38.4135 29.3468 38.2268 28.9468 37.8268L19.5335 28.4135C18.7602 27.6402 18.7602 26.3602 19.5335 25.5868L28.9468 16.1735C29.7202 15.4002 31.0002 15.4002 31.7735 16.1735C32.5468 16.9468 32.5468 18.2268 31.7735 19.0002L23.7735 27.0002L31.7735 35.0002Z"
								fill={isBeginning ? "#C2C3C3" : "var(--primary-color)"}
							/>
						</svg>
					</button>
					<button className="button-next" ref={nextRef}>
						<svg
							width="54"
							height="54"
							viewBox="0 0 54 54"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M27.0002 0.333496C12.3068 0.333496 0.333496 12.3068 0.333496 27.0002C0.333496 41.6935 12.3068 53.6668 27.0002 53.6668C41.6935 53.6668 53.6668 41.6935 53.6668 27.0002C53.6668 12.3068 41.6935 0.333496 27.0002 0.333496ZM34.4402 28.4135L25.0268 37.8268C24.6268 38.2268 24.1202 38.4135 23.6135 38.4135C23.1068 38.4135 22.6002 38.2268 22.2002 37.8268C21.4268 37.0535 21.4268 35.7735 22.2002 35.0002L30.2002 27.0002L22.2002 19.0002C21.4268 18.2268 21.4268 16.9468 22.2002 16.1735C22.9735 15.4002 24.2535 15.4002 25.0268 16.1735L34.4402 25.5868C35.2402 26.3602 35.2402 27.6402 34.4402 28.4135Z"
								fill={!isEnd ? "var(--primary-color)" : "#C2C3C3"}
							/>
						</svg>
					</button>
					<Swiper
						slidesPerView={1}
						spaceBetween={16}
						onInit={(swiper) => {
							swiper.params.navigation.prevEl = prevRef.current;
							swiper.params.navigation.nextEl = nextRef.current;
							swiper.navigation.init();
							swiper.navigation.update();
						}}
						onSlideChange={(swiper) => {
							setIsBeginning(swiper.isBeginning);
							setIsEnd(swiper.isEnd);
						}}
						scrollbar={{ draggable: true }}
						modules={[Navigation]}
						breakpoints={{
							640: {
								slidesPerView: 1,
								spaceBetween: 16,
							},
							768: {
								slidesPerView: 2,
								spaceBetween: 24,
							},
							1024: {
								slidesPerView: 3,
								spaceBetween: 32,
							},
						}}
						style={{ direction: "ltr" }}
						className="mySwiper">
						{data?.map((person, index) => {
							return (
								<SwiperSlide key={index}>
									<div className="team" data-aos="zoom-in">
										<img src={person?.image} alt="person" />
										<div className="details">
											<p className="name">{person[`title_${lang}`]}</p>
											<p className="job">{person[`job_${lang}`]}</p>
										</div>
									</div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				</div>
			</div>
		</div>
	);
};
export default Leadership;
